var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.similarities
    ? _c(
        "div",
        {
          staticClass: "form-group row mt-4",
          attrs: { role: "group", "aria-labelledby": _vm.title }
        },
        [
          _c("plain-text-control", {
            staticClass: "col-xs-12 col-sm-5",
            attrs: { id: _vm.title, title: _vm.title, required: true }
          }),
          _vm._v(" "),
          _c("ValidationProvider", {
            attrs: { rules: { required: { allowFalse: false } }, slim: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    var failedRules = ref.failedRules
                    return [
                      _c("div", { staticClass: "col-xs-12 col-sm-7" }, [
                        _c("div", {
                          staticClass: "d-none",
                          model: {
                            value: _vm.selectionMade,
                            callback: function($$v) {
                              _vm.selectionMade = $$v
                            },
                            expression: "selectionMade"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "radio-checkbox-group",
                            class: _vm.getValidationErrorClasses(failedRules),
                            attrs: { "aria-invalid": errors.length > 0 }
                          },
                          [
                            _c("check-box-control", {
                              attrs: {
                                name: _vm.title,
                                title: _vm.nonProfitStr,
                                id: _vm.nonProfitStr,
                                isDisabled: _vm.similarities.nonProfit
                                  ? false
                                  : _vm.similarities.none
                              },
                              model: {
                                value: _vm.similarities.nonProfit,
                                callback: function($$v) {
                                  _vm.$set(_vm.similarities, "nonProfit", $$v)
                                },
                                expression: "similarities.nonProfit"
                              }
                            }),
                            _vm._v(" "),
                            _c("check-box-control", {
                              attrs: {
                                name: _vm.title,
                                title: _vm.commercialActivityStr,
                                id: _vm.commercialActivityStr,
                                isDisabled: _vm.similarities.commercialActivity
                                  ? false
                                  : _vm.similarities.none
                              },
                              model: {
                                value: _vm.similarities.commercialActivity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.similarities,
                                    "commercialActivity",
                                    $$v
                                  )
                                },
                                expression: "similarities.commercialActivity"
                              }
                            }),
                            _vm._v(" "),
                            _c("check-box-control", {
                              attrs: {
                                name: _vm.title,
                                title: _vm.publicSectorStr,
                                id: _vm.publicSectorStr,
                                isDisabled: _vm.similarities.publicSector
                                  ? false
                                  : _vm.similarities.none
                              },
                              model: {
                                value: _vm.similarities.publicSector,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.similarities,
                                    "publicSector",
                                    $$v
                                  )
                                },
                                expression: "similarities.publicSector"
                              }
                            }),
                            _vm._v(" "),
                            _c("check-box-control", {
                              attrs: {
                                name: _vm.title,
                                title: _vm.noneStr,
                                id: _vm.noneStr,
                                isDisabled: _vm.similarities.none
                                  ? false
                                  : _vm.hasSimilarities
                              },
                              model: {
                                value: _vm.similarities.none,
                                callback: function($$v) {
                                  _vm.$set(_vm.similarities, "none", $$v)
                                },
                                expression: "similarities.none"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  }
                }
              ],
              null,
              false,
              840752496
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }